import {
  BasketballEventStatusId,
  BasketballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { ManualAddIncidentConfig } from '../../configuration'
import { useBasketballSeasonDetails } from '../composables'

const keyIncidents = [
  BasketballIncidentId.ThreePointShotMade,
  BasketballIncidentId.TwoPointShotMade,
  BasketballIncidentId.FreeThrowIn,
  BasketballIncidentId.ThreePointShotMissed,
  BasketballIncidentId.TwoPointShotMissed,
  BasketballIncidentId.FreeThrowMissed,
  BasketballIncidentId.FreeThrowsAwarded,
]

export const manualAddIncidentConfig: ManualAddIncidentConfig<
  BasketballIncidentId,
  BasketballEventStatusId
> = {
  getKeyIncidents: () => {
    const { isFourPointsShotEnabled } = useBasketballSeasonDetails()

    if (isFourPointsShotEnabled) {
      return [
        BasketballIncidentId.FourPointShotMade,
        BasketballIncidentId.ThreePointShotMade,
        BasketballIncidentId.TwoPointShotMade,
        BasketballIncidentId.FreeThrowIn,
        BasketballIncidentId.FourPointShotMissed,
        BasketballIncidentId.ThreePointShotMissed,
        BasketballIncidentId.TwoPointShotMissed,
        BasketballIncidentId.FreeThrowMissed,
        BasketballIncidentId.FreeThrowsAwarded,
      ]
    }

    return keyIncidents
  },

  otherIncidents: [
    BasketballIncidentId.DefensiveRebound,
    BasketballIncidentId.OffensiveRebound,
    BasketballIncidentId.Turnover,
    BasketballIncidentId.Steal,
    BasketballIncidentId.Block,
    BasketballIncidentId.Foul,
  ],
  eventStatuses: [
    BasketballEventStatusId.FirstQuarter,
    BasketballEventStatusId.SecondQuarter,
    BasketballEventStatusId.ThirdQuarter,
    BasketballEventStatusId.FourthQuarter,
    BasketballEventStatusId.BreakAfterFirstQuarter,
    BasketballEventStatusId.BreakAfterSecondQuarter,
    BasketballEventStatusId.BreakAfterThirdQuarter,
    BasketballEventStatusId.WaitingForOvertime,
  ],
}
